import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHookSection } from './components/OpeningHookSection';
import { ProblemSection } from './components/ProblemSection';
import { WhyItDidntWorkSection } from './components/WhyItDidntWorkSection';
import { BenefitsSection } from './components/BenefitsSection';
import { WhoItsForSection } from './components/WhoItsForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { OfferSection } from './components/OfferSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-bg-primary font-inter" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHookSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <WhyItDidntWorkSection data-id="element-4" />
      <BenefitsSection data-id="element-5" />
      <WhoItsForSection data-id="element-6" />
      <HowItWorksSection data-id="element-7" />
      <ProofSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <OfferSection data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}